import React, { useCallback, useRef } from 'react';

import { Global } from '@emotion/react';

import theme, { styled } from '../../theme';
import DatePicker from '../DatePicker';
import FlexRow from '../FlexRow';
import './styles';
import { globalStyles } from './styles';

const View = styled(FlexRow)<Props>(({ theme }) => ({}));

type Props = {
    className?: string;
    from: Date;
    to: Date;
    onFromChange?: (from: Date) => void;
    onToChange?: (to: Date) => void;
};

const startDateStyle = {
    ['border-top-left-radius']: '50%',
    ['border-bottom-left-radius']: '50%',
    ['background-color']: theme.color.green1,
    color: theme.color.text,
};
const endDateStyle = {
    ['border-top-right-radius']: '50%',
    ['border-bottom-right-radius']: '50%',
    ['background-color']: theme.color.green1,
    color: theme.color.text,
};

const DateRangePicker = (props: Props) => {
    const { className, from, to, onFromChange, onToChange } = props;
    const modifiers = { start: from, end: to };
    const toPopperRef = useRef(null);

    const handleFromChange = useCallback(
        ({ target: { value } }: { target: { value: Date } }) => {
            onFromChange && onFromChange(value);
        },
        [onFromChange]
    );

    const handleToChange = useCallback(
        ({ target: { value } }: { target: { value: Date } }) => {
            onToChange && onToChange(value);
        },
        [onToChange]
    );

    const handleSelectFromDay = useCallback(() => {
        toPopperRef?.current?.setPopoverVisibility(true);
    }, []);

    const commonCalendarProps = {
        modifiers,
        selected: [from, { from, to }],
        modifiersStyles: { start: startDateStyle, end: endDateStyle },
    };
    const fromCalendarProps = { toMonth: to, ...commonCalendarProps };
    const toCalendarProps = { fromMonth: from, ...commonCalendarProps };
    const fromInputValidationRules = { toDate: to };
    const toInputValidationRules = { fromDate: from };
    const fromDisabledDays = { after: to };
    const toDisabledDays = { before: from };

    return (
        <>
            <Global styles={globalStyles} />
            <View className={className} itemsSpacing={15}>
                <DatePicker
                    size="large"
                    label="From"
                    name="from"
                    datePickerClassName="date-range-picker"
                    disabledDays={fromDisabledDays}
                    calendarProps={fromCalendarProps}
                    inputValidationRules={fromInputValidationRules}
                    value={from}
                    onChange={handleFromChange}
                    onSelectDay={handleSelectFromDay}
                />
                <DatePicker
                    size="large"
                    label="To"
                    name="to"
                    datePickerClassName="date-range-picker"
                    ref={toPopperRef}
                    disabledDays={toDisabledDays}
                    calendarProps={toCalendarProps}
                    inputValidationRules={toInputValidationRules}
                    value={to}
                    onChange={handleToChange}
                />
            </View>
        </>
    );
};
export default DateRangePicker;
